import { toHaveDisplayValue } from "@testing-library/jest-dom/dist/matchers";
import axios from "axios";
import { encode as base64_encode } from "base-64";
import React from "react";
import InputMask from "react-input-mask";
import { Select, Checkbox } from "react-materialize";
import { ConfigurarSas } from "../../components/GatewaySas/GatewaySas";
import HeaderPage from "../../components/PageHeader/PageHeader";
import StepCounter from "../../components/StepCounter/StepCounter";
import "../../index.css";
import { retornarObterCep } from "../../services/cepservice";
import { inserirCookie, retornarCookie } from "../../services/cookieservice";
import { obterConfiguracaoNivel2 } from "../../services/nivel2service";
import Loader from "../../components/Loader/Loader";
import { verificarBloqueioCnpj } from "../../services/bloqueioCnpjService";
import { cnpjCanonical, cnpjValidate } from "../../services/cnpjService";

const {
  REACT_APP_API,
  REACT_APP_URL_INSTANCE,
  REACT_APP_SAS_URL,
  REACT_APP_COMISSAO_MEDICINA_PADRAO,
  REACT_APP_TIPO_CONTRATACAO_PADRAO,
} = process.env;

const parseBooleanEnv = (value) => {
  const normalized = (value || "")
    .toString()
    .trim()
    .replace(/^['\"]|['\"]$/g, "")
    .toLowerCase();

  return ["true", "1", "sim", "yes", "y"].includes(normalized);
};

const FORCAR_FLUXO_LEGADO_VIDAS = parseBooleanEnv(
  process.env.REACT_APP_FORCAR_FLUXO_LEGADO_VIDAS
);

export default class DadosEmpresaPage extends React.Component {
  state = {
    PermiteCnpj: "NAO",
    MultiPropostaFlag: false,
    OportunidadeMultiProposta: undefined,
    OportunidadeId: undefined,
    CepInfo: undefined,
    estados: [],
    cidades: [],
    Cep: "",
    Cnpj: "",
    EstadoID: undefined,
    CidadeID: undefined,
    QtdeVidas: 0,
    QtdeVidasTit: 0,
    RazaoSocial: "",
    sessionId: undefined,
    ContatoEmpresa: undefined,
    permiteContinuar: false,
    cepSemPlano: false,
    TipoContratacao: undefined,
    CodigoComissaoMedicina: undefined,
    IdFilial: retornarCookie("Filial"),
    MEI: false,
    PossuiBenefExtensao: false,
    PossuiProdutosOmint: false,
    RetornoAPIComErro: false,
    exibeCarregamento: false,
    ListaComissaoMedicina: [],
    ListaComissaoOdonto: [],
    ComissaoMedicinaSelecionado: undefined,
    ComissaoOdontoSelecionado: undefined,
    checkComissaoMedicina: false,
    checkComissaoOdonto: false,
    configuracaoNivel2: null,
    limiteMaximoVidasLegado: null,
    fonteLimiteVidas: null,
    cnpjBloqueado: false,
    cnpjBloqueadoMensagem: "",
  };

  handleChangeSelect = (event) => {
    if ([event.target.name] == "EstadoID") {
      this.CarregarCidades(event.target.value);
    }

    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  verificarCNPJValido = (cnpj) => {
    return cnpjValidate(cnpj);
  };


  componentDidMount() {
    this.carregarLimiteVidas();

    const urlParams = new URLSearchParams(window.location.search);

    var MultiProposta = urlParams.get("MultiProposta");

    if (MultiProposta !== null) {
      this.setState({ permiteContinuar: true });
    }

    var OportunidadeId = urlParams.get("MultiProposta");

    if (OportunidadeId !== "" && OportunidadeId !== "undefined" && OportunidadeId !== null) {
      this.ObterInformacoesPropostaMulti(OportunidadeId).then(() => {
        document.getElementById("Cnpj").style.textAlign = "right";
        document.getElementById("Cnpj").disabled = true;

        const cnpjMultiProposta =
          this.state.OportunidadeMultiProposta?.Cnpj?.toUpperCase() || "";

        document.getElementById("Cnpj").value =
          cnpjMultiProposta;
        this.setState({ Cnpj: cnpjMultiProposta });

        document.getElementById("RazaoSocial").style.textAlign = "right";
        document.getElementById("RazaoSocial").disabled = true;
        document.getElementById("RazaoSocial").value =
          this.state.OportunidadeMultiProposta?.RazaoSocial;
        this.setState({
          RazaoSocial: this.state.OportunidadeMultiProposta?.RazaoSocial,
        });

        document.getElementById("ContatoEmpresa").style.textAlign = "right";
        document.getElementById("ContatoEmpresa").disabled = true;
        document.getElementById("ContatoEmpresa").value =
          this.state.OportunidadeMultiProposta?.ContatoNome;
        this.setState({
          ContatoEmpresa: this.state.OportunidadeMultiProposta?.ContatoNome,
        });

        document.getElementById("Cep").style.textAlign = "right";
        document.getElementById("Cep").disabled = true;
        document.getElementById("Cep").value =
          this.state.OportunidadeMultiProposta?.CEP.replace("-", "");
        this.setState({
          Cep: this.state.OportunidadeMultiProposta?.CEP.replace("-", ""),
        });

        document.getElementById("EstadoID").style.textAlign = "right";
        document.getElementById("EstadoID").disabled = true;
        document.getElementById("EstadoID").value =
          this.state.OportunidadeMultiProposta?.EstadoID;
        this.setState({
          EstadoID: this.state.OportunidadeMultiProposta?.EstadoID,
        });

        document.getElementById("CidadeID").style.textAlign = "right";
        document.getElementById("CidadeID").disabled = true;
        document.getElementById("CidadeID").value =
          this.state.OportunidadeMultiProposta?.CidadeID;
        this.setState({
          CidadeID: this.state.OportunidadeMultiProposta?.CidadeID,
        });

        document.getElementById("QtdeVidas").style.textAlign = "right";
        document.getElementById("QtdeVidas").value =
          this.state.OportunidadeMultiProposta?.QtdeVidas;
        this.setState({
          QtdeVidas: this.state.OportunidadeMultiProposta?.QtdeVidas,
        });

        document.getElementById("QtdeVidasTit").style.textAlign = "right";
        document.getElementById("QtdeVidasTit").value =
          this.state.OportunidadeMultiProposta?.QtdeVidasTit;

        this.setState({
          QtdeVidasTit: this.state.OportunidadeMultiProposta?.QtdeVidasTit,
        });



        document.getElementById("checkComissaoMedicina").style.textAlign = "right";
        document.getElementById("checkComissaoMedicina").disabled = true;
        let checkedMedicina = this.state.OportunidadeMultiProposta?.CodigoComissaoMedicina ? true : false;
        document.getElementById("checkComissaoMedicina").checked = checkedMedicina;

        this.setState({
          checkComissaoMedicina: checkedMedicina
        });

        document.getElementById("checkComissaoOdonto").style.textAlign = "right";
        document.getElementById("checkComissaoOdonto").disabled = true;
        let checkedOdonto = this.state.OportunidadeMultiProposta?.CodigoComissaoOdonto ? true : false;
        document.getElementById("checkComissaoOdonto").checked = checkedOdonto;

        this.setState({
          checkComissaoMedicina: checkedOdonto
        });

        this.setState({ MultiPropostaFlag: true });
      });
    }

    this.CarregarEstados();

  }

  obterLimiteMaximoVidasLegado = async () => {
    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
    const response = await axios.get(`${REACT_APP_API}Elegibilidade/MaximoVidas`);
    const qtdVidas = parseInt(response?.data?.QtdVidas, 10);

    if (!Number.isFinite(qtdVidas)) {
      throw new Error("Resposta inválida em Elegibilidade/MaximoVidas.");
    }

    return qtdVidas;
  };

  carregarLimiteVidas = async () => {
    if (FORCAR_FLUXO_LEGADO_VIDAS) {
      try {
        const limiteMaximoVidasLegado = await this.obterLimiteMaximoVidasLegado();
        this.setState({
          configuracaoNivel2: null,
          limiteMaximoVidasLegado,
          fonteLimiteVidas: "legado",
        });
      } catch (erroLegado) {
        console.error("Falha ao carregar limite legado de vidas:", erroLegado);
        this.setState({
          configuracaoNivel2: null,
          limiteMaximoVidasLegado: null,
          fonteLimiteVidas: "indisponivel",
        });
      }
      return;
    }

    try {
      const configuracaoNivel2 = await obterConfiguracaoNivel2();
      const minVidas = parseInt(
        configuracaoNivel2?.MinVidas ?? configuracaoNivel2?.minVidas,
        10
      );
      const maxVidas = parseInt(
        configuracaoNivel2?.MaxVidas ?? configuracaoNivel2?.maxVidas,
        10
      );

      if (!Number.isFinite(minVidas) || !Number.isFinite(maxVidas)) {
        throw new Error("Configuração de vidas do nível 2 inválida.");
      }

      this.setState({
        configuracaoNivel2,
        limiteMaximoVidasLegado: null,
        fonteLimiteVidas: "nivel2",
      });
      return;
    } catch (erroNivel2) {
      console.error("Falha ao carregar configuração do nível 2:", erroNivel2);
    }

    try {
      const limiteMaximoVidasLegado = await this.obterLimiteMaximoVidasLegado();
      this.setState({
        configuracaoNivel2: null,
        limiteMaximoVidasLegado,
        fonteLimiteVidas: "legado",
      });
    } catch (erroLegado) {
      console.error("Falha ao carregar limite legado de vidas:", erroLegado);
      this.setState({
        configuracaoNivel2: null,
        limiteMaximoVidasLegado: null,
        fonteLimiteVidas: "indisponivel",
      });
    }
  };

  carregarComissoesFixas = (QtdeVidas) => {

    if (QtdeVidas !== null && QtdeVidas !== undefined && QtdeVidas !== "") {

      axios
        .get(
          `${REACT_APP_API}comissao/medicina?qtdeVidas=${QtdeVidas
          }&cdAgenteVendas=${retornarCookie(
            "CdAgenteVendas"
          )}&idFilial=${parseInt(retornarCookie("Filial"))}`
        )
        .then((res) => {
          const ListaComissaoMedicina = res.data;
          this.setState({ ListaComissaoMedicina });



          //Seleciona a comissão default (primeira da lista)
          const ComissaoMedicinaSelecionado = ListaComissaoMedicina[0].Id;
          this.setState({ ComissaoMedicinaSelecionado });

        });

      axios
        .get(
          `${REACT_APP_API}comissao/odonto?qtdeVidas=${QtdeVidas
          }&cdAgenteVendas=${retornarCookie(
            "CdAgenteVendas"
          )}&idFilial=${parseInt(retornarCookie("Filial"))}`
        )
        .then((res) => {
          const ListaComissaoOdonto = res.data;
          this.setState({ ListaComissaoOdonto });

          //Seleciona a comissão default (primeira da lista)
          const ComissaoOdontoSelecionado = ListaComissaoOdonto[0].Id;
          this.setState({ ComissaoOdontoSelecionado });

        });
    }

  }

  ObterInformacoesPropostaMulti = async (OportunidadeId) => {
    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
    await axios
      .get(
        `${REACT_APP_API}oportunidade/OportunidadePorId?oportunidadeID=${OportunidadeId}&CdAgenteVendas=${retornarCookie(
          "CdAgenteVendas"
        )}&IdAgenteVendas=${retornarCookie("IdAgenteVenda")}`
      )
      .then((res) => {
        const OportunidadeMultiProposta = res.data;
        this.setState({ OportunidadeMultiProposta });
      });
  };

  onChangeCep = async (e) => {
    this.setState({ cepSemPlano: false });
    this.setState({ CidadeID: undefined });
    this.setState({ EstadoID: undefined });
    this.setState({ CepInfo: undefined });

    if (document.getElementById("Cep").value !== "") {
      const value = e.target.value.replace(/\D/g, "");

      this.setState({ Cep: value });

      if (value.length === 8) {
        try {
          this.setState({ exibeCarregamento: true });

          const sessionId = await ConfigurarSas();

          let result = await retornarObterCep(sessionId, value);
          if (result === null || result === undefined || !result.CIDADE || !result.UF) {
            result = { CIDADE: "", UF: "" };
          }

          this.setState({ CepInfo: result });

          document.getElementById("EstadoID").disabled = true;
          document.getElementById("CidadeID").disabled = true;

          // se nao encontrar o estado
          if (!result.UF) {

            let achouDadosCep = false;

            // tentativa 1 => viacep
            let cepInfoDaViaCep = await this.BuscarCepViaCep(value);
            if (cepInfoDaViaCep.achou) {
              this.setState({ CepInfo: { CIDADE: cepInfoDaViaCep.cidade, UF: cepInfoDaViaCep.uf } });
              achouDadosCep = true;
            }

            if (!achouDadosCep) {
              // tentativa 2 => brasilapi
              let cepInfoDaBrasilApi = await this.BuscarCepViaBrasilApi(value);
              if (cepInfoDaBrasilApi.achou) {
                this.setState({ CepInfo: { CIDADE: cepInfoDaBrasilApi.cidade, UF: cepInfoDaBrasilApi.uf } });
                achouDadosCep = true;
              }
            }

            if (!achouDadosCep) {
              // tentativa 3 => wsapicep
              let cepInfoDaWsApiCep = await this.BuscarCepViaWsApiCep(value);
              if (cepInfoDaWsApiCep.achou) {
                this.setState({ CepInfo: { CIDADE: cepInfoDaWsApiCep.cidade, UF: cepInfoDaWsApiCep.uf } });
                achouDadosCep = true;
              }
            }

            if (!achouDadosCep) {
              // tentativa 4 => opencep
              let cepInfoDaOpenCepApi = await this.BuscarCepViaOpenCepApi(value);
              if (cepInfoDaOpenCepApi.achou) {
                this.setState({ CepInfo: { CIDADE: cepInfoDaOpenCepApi.cidade, UF: cepInfoDaOpenCepApi.uf } });
                achouDadosCep = true;
              }
            }

            if (!achouDadosCep) {
              // parar execução, não achou dados do cep
              alert("CEP não encontrado.");
              throw new Error("CEP não encontrado."); // para a execução do método
            }

          }

          const filtroSigla = this.state.estados.filter(
            (item) => item.Sigla.trim().toLowerCase() === this.state.CepInfo.UF.trim().toLowerCase()
          );

          // tem que achar o estado, se não achar, parar execução
          if (filtroSigla.length === 0) {
            alert("Erro ao buscar detalhes do CEP.");
            throw new Error("O Estado do CEP não retornou da lista permitida da Omint "); // para a execução do método
          }

          let EstadoIdFiltro = filtroSigla[0].Id;
          this.setState({ EstadoID: EstadoIdFiltro });

          axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
          const res = await axios.get(
            `${REACT_APP_API}dominio/cidades?estadoId=${EstadoIdFiltro}`
          );
          const cidades = res.data;

          // remover acentos da cidade do cep, mas, fazendo o replace de acentos por caracteres sem acento, e uppercase
          const CepInfoCidade = this.state.CepInfo.CIDADE.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toUpperCase();
          const CepInfoCidadeSomenteLetras = CepInfoCidade.replace(/[^a-zA-Z ]/g, "").trim().toUpperCase();

          // funcão para transformar a string do nome da cidade no CRM para somente letras
          // e uppercase, para comparar com a cidade do cep
          const removeAcento = (str) => {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toUpperCase();
          };

          const manterSomenteLetras = (str) => {
            return str.replace(/[^a-zA-Z ]/g, "").trim().toUpperCase();
          };

          const filtroCidade = cidades.filter(
            (item) => CepInfoCidade === removeAcento(item.Nome.trim())
              || CepInfoCidadeSomenteLetras === manterSomenteLetras(item.Nome.trim())
          );

          // tem que achar a cidade
          if (filtroCidade.length === 0) {
            alert("Cidade não encontrada para o estado informado.");
            throw new Error("Cidade não encontrada para o estado informado."); // para a execução do método
          }

          let CidadeIdFiltro = filtroCidade[0].Id;
          this.setState({ CidadeID: CidadeIdFiltro });

          const permissaoCepRegiao = await this.VerificarCepPermitido(
            value,
            sessionId
          );

          this.setState({ exibeCarregamento: false });

          if (permissaoCepRegiao.cd_plano === "NC") {
            this.setState({ cepSemPlano: true });
            this.setState({ permiteContinuar: false });
            alert("Não existem planos disponíveis para este CEP.");
          }

          this.VerificaPermiteContinuar();
        } catch (error) {
          this.setState({ RetornoAPIComErro: true });
          console.error(error);
          this.setState({ exibeCarregamento: false });
        }
      }
    }
  };

  BuscarCepViaCep = async (value) => {
    try {
      // tenta recuperar dados do cep da api viacep => retorno {cep, logradouro, complemento, bairro, localidade, uf, ibge, gia, ddd, siafi}
      const cepInfoDaViaCep = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
      if (!cepInfoDaViaCep.data.uf || !cepInfoDaViaCep.data.localidade) {
        return { achou: false }
      }

      return { achou: true, cidade: cepInfoDaViaCep.data.localidade, uf: cepInfoDaViaCep.data.uf };
    }
    catch (error) {
      console.error(error);
      return { achou: false }
    }
  };

  BuscarCepViaBrasilApi = async (value) => {
    try {
      // tenta recuperar dados do cep da api brasilapi => retorno { cep, state, city, neighborhood, street}
      const cepInfoDaBrasilApi = await axios.get(`https://brasilapi.com.br/api/cep/v1/${value}`);
      if (!cepInfoDaBrasilApi.data.state || !cepInfoDaBrasilApi.data.city) {
        return { achou: false }
      }

      return { achou: true, cidade: cepInfoDaBrasilApi.data.city, uf: cepInfoDaBrasilApi.data.state };
    } catch (error) {
      console.error(error);
      return { achou: false }
    }
  };

  BuscarCepViaWsApiCep = async (value) => {
    try {
      // tenta recuperar dados do cep da api wsapicep => retorno {code, state, city, address, district}
      const cepInfoDaWsApiCep = await axios.get(`https://ws.apicep.com/cep.json?code=${value}`);
      if (!cepInfoDaWsApiCep.data.state || !cepInfoDaWsApiCep.data.city) {
        return { achou: false }
      }

      return { achou: true, cidade: cepInfoDaWsApiCep.data.city, uf: cepInfoDaWsApiCep.data.state };
    }
    catch (error) {
      console.error(error);
      return { achou: false }
    }
  };

  BuscarCepViaOpenCepApi = async (value) => {
    try {
      // tenta recuperar dados do cep da api opencep => retorno {cep, logradouro, complemento, unidade, bairro, localidade, uf, ibge }
      const cepInfoDaOpenCepApi = await axios.get(`https://opencep.com/v1/${value}`);
      if (!cepInfoDaOpenCepApi.data.uf || !cepInfoDaOpenCepApi.data.localidade) {
        return { achou: false }
      }

      return { achou: true, cidade: cepInfoDaOpenCepApi.data.localidade, uf: cepInfoDaOpenCepApi.data.uf };
    }
    catch (error) {
      console.error(error);
      return { achou: false }
    }
  };

  CarregarEstados = () => {
    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
    axios.get(`${REACT_APP_API}dominio/estados`).then((res) => {
      const estados = res.data;
      this.setState({ estados });
    });
  };

  ValidarCnpj = async (Cnpj) => {
    const urlParams = new URLSearchParams(window.location.search);

    var MultiProposta = urlParams.get("MultiProposta");

    if (MultiProposta === null) {
      axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
      await axios
        .get(
          `${REACT_APP_API}oportunidade/ValidaCnpj?Cnpj=${Cnpj}&id_filial=${retornarCookie(
            "Filial"
          )}`
        )
        .then((res) => {
          const PermiteCnpj = res.data;

          this.setState({ PermiteCnpj });
        });
    }
  };

  onBlurCnpj = async (e) => {
    e.target.value = (e.target.value || "").toUpperCase();
    const cnpjDigitado = cnpjCanonical(e.target.value);

    this.setState({ permiteContinuar: false });

    // Verifica bloqueio de CNPJ no CRM
    try {
      const resultadoBloqueio = await verificarBloqueioCnpj(cnpjDigitado);
      if (resultadoBloqueio?.Bloqueado === true) {
        this.setState({ cnpjBloqueado: true, cnpjBloqueadoMensagem: resultadoBloqueio.Mensagem, permiteContinuar: false });
        return;
      }
    } catch (error) {
      console.error("Erro ao verificar bloqueio de CNPJ:", error);
    }
    this.setState({ cnpjBloqueado: false, cnpjBloqueadoMensagem: "" });

    const sessionId = await ConfigurarSas();
    var ValidaCnpj = this.CarregarValidacaoCnpj(cnpjDigitado, sessionId).then(
      async (result) => {
        if (
          result.Retorno.toString() == "RJ00124" ||
          result.Retorno.toString() == "EA00126"
        ) {
          alert(
            "Este CNPJ pertence a um cliente ativo. Para realizar a solicitação de estudo, favor entrar em contato com a KIPP."
          );
        } else {
          this.setState({ Cnpj: cnpjDigitado });
        }
      }
    );

    await this.ValidarCnpj(cnpjDigitado);

    this.VerificaPermiteContinuar();
  };

  onChange = (e) => {
    this.setState(
      (prevState) => {
        const newState = {};

        if (e.target.name === "checkComissaoOdonto" || e.target.name === "checkComissaoMedicina") {
          newState[e.target.name] = e.target.checked;

          if (e.target.name === "checkComissaoOdonto") {
            inserirCookie("ComissaoOdonto", this.state.ComissaoOdontoSelecionado || "");
          }

          if (e.target.name === "checkComissaoMedicina") {
            inserirCookie("ComissaoMedicina", this.state.ComissaoMedicinaSelecionado || "");
          }
        } else {
          newState[e.target.name] = e.target.value;
        }

        return newState;
      },
      () => {
        this.VerificaPermiteContinuar();
      }
    );
  };

  VerificarCepPermitido = async (Cep, sessionId) => {
    const headers = { "Content-Type": "application/json" };

    const body = JSON.stringify({
      SessionID: sessionId,
      screenIdentification: "SASGC0087",
      Parameters: [
        {
          parametername: "ve_id_filial",
          parametervalue: retornarCookie("Filial"),
        },
        {
          parametername: "ve_nr_cep",
          parametervalue: Cep,
        },
        {
          parametername: "ve_id_plano",
          parametervalue: "",
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers,
      body,
    };

    return await fetch(`${REACT_APP_SAS_URL}`, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        return result.responseJSONData
          ? result.responseJSONData.find(() => true)
          : undefined;
      });
  };

  CarregarValidacaoCnpj = async (cnpj, sessionId) => {
    const headers = { "Content-Type": "application/json" };

    const body = JSON.stringify({
      SessionID: sessionId,
      screenIdentification: "SASGC0066",
      Parameters: [
        {
          parametername: "CNPJ",
          parametervalue: cnpj,
        },
        {
          parametername: "id_filial",
          parametervalue: retornarCookie("Filial"),
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers,
      body,
    };

    return await fetch(`${REACT_APP_SAS_URL}`, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        return result.responseJSONData.shift();
      });
  };

  CarregarCidades = (EstadoId) => {
    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
    axios
      .get(`${REACT_APP_API}dominio/cidades?estadoId=${EstadoId}`)
      .then((res) => {
        const cidades = res.data;
        this.setState({ cidades });
      });
  };

  CadastrarDadosEmpresa = async () => {
    this.setState({ exibeCarregamento: true });

    var cepsemformatacao = this.state.Cep.replace("-", "");

    if (this.state.MultiPropostaFlag === true) {
      await axios
        .post(
          `${REACT_APP_API}oportunidade?IdAgenteVendas=${retornarCookie(
            "IdAgenteVenda"
          )}&CdAgenteVendas=${retornarCookie("CdAgenteVendas")}`,
          {
            OportunidadeGUID_CRM:
              this.state.OportunidadeMultiProposta.OportunidadeGUID_CRM,
            OportunidadeID_CRM:
              this.state.OportunidadeMultiProposta.OportunidadeID_CRM,
            ContatoNome: this.state.ContatoEmpresa,
            Cep: cepsemformatacao,
            CidadeID: !this.state.CidadeID ? null : this.state.CidadeID,
            Cnpj: this.state.Cnpj,
            EstadoID: !this.state.EstadoID ? null : this.state.EstadoID,
            QtdeVidas: this.state.QtdeVidas,
            QtdeVidasTit: this.state.QtdeVidasTit,
            RazaoSocial: this.state.RazaoSocial,
            MultiplasPropostas: this.state.MultiPropostaFlag,
            IdFilial: this.state.IdFilial,
            TipoContratacao: this.state.TipoContratacao,
            CodigoComissaoMedicina: this.state.OportunidadeMultiProposta.CodigoComissaoMedicina,
            CodigoComissaoOdonto: this.state.OportunidadeMultiProposta.CodigoComissaoOdonto,
            MEI: false,
            PossuiBenefExtensao: false,
            PossuiProdutosOmint: false,
          }
        )
        .then((res) => {
          const Oportunidade = res.data;
          this.setState({ OportunidadeId: Oportunidade.OportunidadeID });
          this.setState({ exibeCarregamento: false });
        })
        .catch((error) => {
          console.error(error);
          this.setState({ RetornoAPIComErro: true });
        });
    } else {

      await axios
        .post(
          `${REACT_APP_API}oportunidade?IdAgenteVendas=${retornarCookie(
            "IdAgenteVenda"
          )}&CdAgenteVendas=${retornarCookie("CdAgenteVendas")}`,
          {
            ContatoNome: this.state.ContatoEmpresa,
            Cep: this.state.Cep,
            CidadeID: !this.state.CidadeID ? null : this.state.CidadeID,
            Cnpj: this.state.Cnpj,
            EstadoID: !this.state.EstadoID ? null : this.state.EstadoID,
            QtdeVidas: this.state.QtdeVidas,
            QtdeVidasTit: this.state.QtdeVidasTit,
            RazaoSocial: this.state.RazaoSocial,
            MultiplasPropostas: this.state.MultiPropostaFlag,
            IdFilial: this.state.IdFilial,
            TipoContratacao: this.state.TipoContratacao,
            // Adicione as condições para CodigoComissaoMedicina e CodigoComissaoOdonto
            ...(this.state.checkComissaoMedicina ? { CodigoComissaoMedicina: this.state.ComissaoMedicinaSelecionado } : {}),
            ...(this.state.checkComissaoOdonto ? { CodigoComissaoOdonto: this.state.ComissaoOdontoSelecionado } : {}),
            MEI: false,
            PossuiBenefExtensao: false,
            PossuiProdutosOmint: false,
          }
        )
        .then((res) => {
          const Oportunidade = res.data;
          this.setState({ OportunidadeId: Oportunidade.OportunidadeID });
        })
        .catch((error) => {
          console.error(error);
          this.setState({ RetornoAPIComErro: true });
        });
    }
  };

  VerificaPermiteContinuar = () => {
    var campoCnpj = document.getElementById("Cnpj").value;
    var campoRazaoSocial = document.getElementById("RazaoSocial").value;
    var campoContato = document.getElementById("ContatoEmpresa").value;
    var campoCep = document.getElementById("Cep").value;
    var campoQtdVidas = document.getElementById("QtdeVidas").value;
    var campoQtdTitulares = document.getElementById("QtdeVidasTit").value;

    if (
      campoCnpj === "" ||
      campoRazaoSocial === "" ||
      campoContato === "" ||
      campoCep === "" ||
      campoQtdVidas === "" ||
      campoQtdTitulares === "" ||
      this.state.CidadeID === undefined ||
      this.state.EstadoID === undefined ||
      this.state.cepSemPlano === true ||
      this.state.cnpjBloqueado === true ||
      (this.state.checkComissaoMedicina === false &&
        this.state.checkComissaoOdonto === false)
    ) {
      this.setState({ permiteContinuar: false });
    } else {
      this.setState({ permiteContinuar: true });
    }

  };

  classificarFluxoPorVidas = (qtdeVidas) => {
    const { configuracaoNivel2, limiteMaximoVidasLegado, fonteLimiteVidas } =
      this.state;

    if (fonteLimiteVidas === "legado") {
      if (!Number.isFinite(limiteMaximoVidasLegado)) {
        return "configuracao-invalida";
      }

      return qtdeVidas <= limiteMaximoVidasLegado ? "normal" : "nao-permitido";
    }

    if (fonteLimiteVidas !== "nivel2") {
      return "configuracao-invalida";
    }

    const minVidas = parseInt(
      configuracaoNivel2?.MinVidas ?? configuracaoNivel2?.minVidas,
      10
    );
    const maxVidas = parseInt(
      configuracaoNivel2?.MaxVidas ?? configuracaoNivel2?.maxVidas,
      10
    );

    if (!Number.isFinite(minVidas) || !Number.isFinite(maxVidas)) {
      return "configuracao-invalida";
    }

    if (qtdeVidas < minVidas) {
      return "normal";
    }

    if (qtdeVidas <= maxVidas) {
      return "nivel2";
    }

    return "nao-permitido";
  };

  Continuar = async () => {



    var campoCnpj = document.getElementById("Cnpj").value;
    var campoRazaoSocial = document.getElementById("RazaoSocial").value;
    var campoContato = document.getElementById("ContatoEmpresa").value;
    var campoCep = document.getElementById("Cep").value;
    var campoQtdVidas = document.getElementById("QtdeVidas").value;
    var campoQtdTitulares = document.getElementById("QtdeVidasTit").value;

    const urlParams = new URLSearchParams(window.location.search);

    var MultiProposta = urlParams.get("MultiProposta");

    var alertaCnpjInvalido = this.verificarCNPJValido(this.state.Cnpj);

    const qtdeVidas = parseInt(this.state.QtdeVidas, 10);
    const qtdeVidasTit = parseInt(this.state.QtdeVidasTit, 10);
    const classificacaoFluxo = this.classificarFluxoPorVidas(qtdeVidas);

    if (qtdeVidasTit <= 0) {
      alert("Insira um número de titulares maior que zero para continuar.");
    } else if (qtdeVidas <= 0) {
      alert("Insira um número de vidas maior que zero para continuar.");
    } else if (qtdeVidasTit > qtdeVidas) {
      alert("Não é possível ter mais titulares do que vidas no processo.");
    } else if (alertaCnpjInvalido !== true) {
      this.setState({ permiteContinuar: false });
      alert("Insira um cnpj válido para continuar.");
    } else if (
      (this.state.PermiteCnpj.retorno === "NAO" ||
        this.state.PermiteCnpj.retorno === undefined) &&
      MultiProposta === null
    ) {
      alert(
        "Não é possível prosseguir por favor entre em contato com o seu consultor para maiores informações."
      );
    } else if (classificacaoFluxo === "configuracao-invalida") {
      alert(
        "Não foi possível validar a quantidade de vidas no momento. Tente novamente em instantes."
      );
    } else if (classificacaoFluxo === "nao-permitido") {
      alert(
        "Não é possível prosseguir, o número limite de vidas permitidas pelo sistema foi ultrapassado."
      );
    } else if (
      campoCnpj === "" ||
      campoRazaoSocial === "" ||
      campoContato === "" ||
      campoCep === "" ||
      campoQtdVidas === "" ||
      campoQtdTitulares === "" ||
      this.state.CidadeID === undefined || 
      this.state.EstadoID === undefined ||      
      this.state.cepSemPlano == true
    ) {
      alert("Não é possível prosseguir sem preencher todos os campos.");
    } else {
      await this.CadastrarDadosEmpresa().then(() => {
        const ehNivel2 = classificacaoFluxo === "nivel2";

        const redirectTo = ehNivel2
          ? base64_encode("NavigationBar,InformacoesNivel2Page")
          : base64_encode("NavigationBar,ElegibilidadePage");

        if (this.state.RetornoAPIComErro) {
          alert("Não foi possível prosseguir com a proposta.");
          this.setState({ exibeCarregamento: false });
        }
        else {
          document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
            retornarCookie("Auth")
          )}&OportunidadeID=${this.state.OportunidadeId}`;
        }
      });
    }
  };

  render() {
    const passoAtual = () => {
      const qtdeVidas = parseInt(this.state.QtdeVidas || 0, 10);
      const ehNivel2 = this.classificarFluxoPorVidas(qtdeVidas) === "nivel2";

      if (!ehNivel2) {
        return <StepCounter step="1" total="4" />;
      }

      return <StepCounter step="1" total="5" />;
    };

    return (
      <div className="fade-in">
        {this.state.exibeCarregamento && <Loader />}


        <div className="row container">
          <div className="col s9 m9 l9">
            <br />
            <b>
              <h5>Nova Oportunidade</h5>
            </b>
          </div>
          <div className="col s3 m3 l3">
            <br />
            {passoAtual()}
          </div>
        </div>
        <div className="row container">
          <HeaderPage
            Spotlight="Dados"
            Title="da Empresa"
            Description="Para iniciar a nova oportunidade, preencha ao lado os dados cadastrais da empresa, informe a quantidade de pessoas que farão parte do plano, assim como o número de titulares."
          />

          <div className="col s5 m5 l5 offset-s3 offset-m3 offset-l3">
            <div className="input-field col s12">
              <label htmlFor="Cnpj">Cnpj</label>
              {!this.state.OportunidadeMultiProposta?.Cnpj && (
                <InputMask
                  mask="AA.AAA.AAA/AAAA-99"
                  formatChars={{
                    'A': '[A-Za-z0-9]',
                    '9': '[0-9]'
                  }}
                  id="Cnpj"
                  type="text"
                  name="Cnpj"
                  style={{ textTransform: 'uppercase' }}
                  onChange={() => this.setState({ cnpjBloqueado: false })}
                  onBlur={this.onBlurCnpj}
                />
              )}

              {this.state.OportunidadeMultiProposta?.Cnpj && (
                <input
                  id="Cnpj"
                  type="text"
                  name="Cnpj"
                  onChange={() => this.setState({ cnpjBloqueado: false })}
                  onBlur={this.onBlurCnpj}
                />
              )}
              {this.state.cnpjBloqueado && (
                <span style={{ color: "#c62828", fontSize: "12px" }}>
                  {this.state.cnpjBloqueadoMensagem || "Não é possível prosseguir. Entre em contato com o seu consultor."}
                </span>
              )}
            </div>

            <div className="input-field col s12">
              <label htmlFor="RazaoSocial">Razão Social</label>
              <input
                id="RazaoSocial"
                type="text"
                maxLength={150}
                name="RazaoSocial"
                onChange={this.onChange}
                disabled={this.state.cnpjBloqueado}
              />
            </div>

            <div className="input-field col s12">
              <label htmlFor="ContatoEmpresa">Contato da Empresa</label>
              <input
                id="ContatoEmpresa"
                type="text"
                maxLength={50}
                name="ContatoEmpresa"
                onChange={this.onChange}
                disabled={this.state.cnpjBloqueado}
              />
            </div>

            <div className="input-field col s12">
              <label htmlFor="Cep">Cep</label>
              <input
                id="Cep"
                type="text"
                disabled={this.state.cnpjBloqueado}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Tab",
                    "ArrowLeft",
                    "ArrowRight",
                    "-",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                  ];
                  if (!allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                maxLength={9}
                name="Cep"
                onChange={this.onChangeCep}
              />
              {this.state.CepInfo?.CIDADE ? this.state.CepInfo?.CIDADE : ""}{" "}
              {this.state.CepInfo?.UF
                ? " ( " + this.state.CepInfo?.UF + " )"
                : ""}
            </div>

            <div className="input-field col s6 hide">
              <label htmlFor="estado">Estado</label>
              <br />
              <Select
                name="EstadoID"
                id="EstadoID"
                onChange={this.handleChangeSelect}
                defaultValue="0"
                disabled
              >
                <option value="">Selecione o estado</option>
                {this.state.estados.map((estado) => (
                  <option value={estado.Id}>
                    {estado.Nome} - {estado.Sigla}
                  </option>
                ))}
              </Select>
            </div>

            <div className="input-field col s6 hide">
              <label htmlFor="cidade">Cidade</label>
              <br />
              <Select
                name="CidadeID"
                id="CidadeID"
                onChange={this.handleChangeSelect}
                defaultValue="0"
                disabled
              >
                <option value="">Selecione a cidade</option>
                {this.state.cidades.map((cidade) => (
                  <option value={cidade.Id}>{cidade.Nome}</option>
                ))}
              </Select>
            </div>

            <div className="input-field col s12">
              <label htmlFor="QtdeVidas">Quantidade de Vidas</label>
              <input
                id="QtdeVidas"
                maxLength={4}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                }
                type="text"
                name="QtdeVidas"
                onChange={this.onChange}
                disabled={this.state.cnpjBloqueado}
                onBlur={(e) => {
                  this.carregarComissoesFixas(e.target.value)
                }}
              />
            </div>

            <div className="input-field col s12">
              <label htmlFor="QtdeVidasTit">Quantidade de Titulares</label>
              <input
                id="QtdeVidasTit"
                maxLength={4}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                }
                type="text"
                name="QtdeVidasTit"
                onChange={this.onChange}
                disabled={this.state.cnpjBloqueado}
              />
            </div>

            <div className="input-filed col s12">
              <br />
              <Checkbox
                id="checkComissaoMedicina"
                name="checkComissaoMedicina"
                label="Cotar planos médico"
                onChange={(e) => this.onChange(e)}
                disabled={this.state.cnpjBloqueado}
              /><br /><br /><br />
            </div>

            <div className="input-filed col s12">
              <Checkbox
                id="checkComissaoOdonto"
                name="checkComissaoOdonto"
                label="Cotar planos odontológicos"
                onChange={(e) => this.onChange(e)}
                disabled={this.state.cnpjBloqueado}
              /><br /><br />
            </div>

            <div className="col s12 m12 l12">
              <br />
              <button
                type="button"
                className="OmintButton"
                disabled={this.state.permiteContinuar ? false : true}
                onClick={this.Continuar}
              >
                <a className="WhiteText">Continuar</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
